import { $store } from "../main";

export const fn = {
  tracking_data_update: () => {
    $store.dispatch("loadDevices");
    $store.dispatch("loadLocations");
  },
  netzero_data_update: () => {
    $store.dispatch("loadAssets");
  },
  update_store: (type, subtype = null) => {
    if (type == "tracking") {
      fn.tracking_data_update();
    } else if (type == "powerdata" && subtype == "netzero") {
      fn.netzero_data_update();
    }
  },
  update_tenant: (response) => {
    $store.commit("set_tenant_settings", response);
    fn.update_store(response["type"], response["powerdata_type"]);
  },
  merge_locations_obj: (location_list, stats_data, watchlist_data) => {
    let temp = null;
    let location_data = location_list.map((elem) => {
      elem.id = elem.LocationID;
      elem.CurrentLat = elem.Latitude;
      elem.CurrentLng = elem.Longitude;
      elem.markerType = "location_" + elem.LocationType;
      return elem;
    });
    let watchlist =
      watchlist_data &&
      watchlist_data.map((elem) => {
        return elem["LocationID"];
      });
    location_data = location_data.map((elem) => {
      elem.id = elem.LocationID;
      var stats_elem = stats_data.find((e) => e.FullName == elem.FullName);
      elem = { ...elem, ...stats_elem };
      return elem;
    });
    location_data.map((elem) => {
      elem.IsWatchlisted = watchlist.indexOf(elem.LocationID) != -1 ? true : false;
      return elem;
    });
    temp = location_data;
    return temp;
  },
};
